import { CheckCircle2, AlertCircle, Info, X } from "lucide-react";
import { useToastStore } from "@/lib/toast-store";
import { cn } from "@/lib/cn";

const iconFor = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
};

const kindCls = {
  success: "bg-[var(--color-success-bg)] text-[var(--color-success)]",
  error: "bg-[var(--color-danger-bg)] text-[var(--color-danger)]",
  info: "bg-[var(--color-info-bg)] text-[var(--color-info)]",
};

export function Toaster() {
  const items = useToastStore((s) => s.items);
  const dismiss = useToastStore((s) => s.dismiss);
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-20 z-[200] flex flex-col items-center gap-2 px-4 lg:bottom-auto lg:top-6 lg:right-6 lg:left-auto lg:items-end">
      {items.map((it) => {
        const Icon = iconFor[it.kind];
        return (
          <div
            key={it.id}
            className={cn(
              "pointer-events-auto flex max-w-md items-start gap-2 rounded-md px-3 py-2 shadow-sm animate-toast-in",
              kindCls[it.kind],
            )}
          >
            <Icon size={16} className="mt-0.5 shrink-0" />
            <span className="text-[13px] font-medium leading-snug">
              {it.message}
            </span>
            <button
              onClick={() => dismiss(it.id)}
              className="ml-1 -m-1 p-1 rounded hover:bg-black/5"
              aria-label="Dismiss"
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
